<div class="loadspinner" *ngIf="loader">Cargando&#8230;</div>
<nb-card>
    <nb-card-body>
        <ng2-smart-table [settings]="settings" [source]="data_source">
        </ng2-smart-table>
    </nb-card-body>
</nb-card>